import { render } from "./Hotspot.vue?vue&type=template&id=735f259b"
import script from "./Hotspot.vue?vue&type=script&lang=js"
export * from "./Hotspot.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__